import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { createTableHeader } from "../helpers";
import { diseaseTableHeaders } from "./Constants";

const getDiseaseRelationsRow = (item) => {
  let row = null;
  if (item) {
    row = (
      <tr
        key={item.key}
        className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
      >
        {diseaseTableHeaders.map((i) => {
          if (i.key === "name") {
            return (
              <td key={i.key} className={`${i.class} tw-p-2.5`}>
                <a href={getVarsoUrl(item.diseaseNameIdUrl)} target="_blank">
                  {item[i.key] || "-"}
                </a>
              </td>
            );
          }
          return (
            <td key={i.key} className={`${i.class} tw-p-2.5`}>
              {item[i.key] || "-"}
            </td>
          );
        })}
      </tr>
    );
  }
  return row;
};

const createTableRows = (items) => {
  const rows = [];
  items.forEach((item) => {
    rows.push(getDiseaseRelationsRow(item));
  });
  return rows;
};

export const getDiseaseRelationsTable = (items) => {
  if (Array.isArray(items) && items.length !== 0) {
    const rows = createTableRows(items);
    const result = (
      <table className="tw-w-full tw-border-collapse tw-border-t tw-border-solid tw-border-gray-200 tw-break-words tw-font-saphetor">
        {createTableHeader(diseaseTableHeaders)}
        <Expander showMore="10" columns="4" component="tbody">
          {rows}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
